import { deselectAllChats, toggleChatListPending } from './actions';
import {
  fetchChatsBulkOperationsReadDesktop,
  TChatsBulkOperationsReadDesktopResponse,
} from '../../repositories/chats/v1/chats-bulk-operations-read-desktop';
import { TThunkAction } from '../../types/redux/thunk';
import { showAlert } from '../alert';

/**
 * Пометить чаты как прочитанные
 * @param {string[]} chatIds массив id чатов
 */
export const markChatsAsRead =
  (chatIds: string[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsReadDesktopResponse =
        await fetchChatsBulkOperationsReadDesktop({
          httpApi,
          parameters: {
            chatIds,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode === 200) {
        dispatch(deselectAllChats());
      } else {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось пометить чаты прочитанными',
          domain: 'src/shared/actions/chatList/markChatsAsRead.ts',
          statusCode,
          messsage: response.message,
          errors: JSON.stringify(response.errors),
        });

        dispatch(showAlert({ message: 'Не удалось пометить чаты прочитанными' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось пометить чаты прочитанными',
        domain: 'src/shared/actions/chatList/markChatsAsRead.ts',
      });

      dispatch(showAlert({ message: 'Не удалось пометить чаты прочитанными' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
